import { render, staticRenderFns } from "./messaggi.vue?vue&type=template&id=15d94c23&"
import script from "./messaggi.vue.ts?vue&type=script&lang=ts&"
export * from "./messaggi.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports